module.exports = __webpack_public_path__ + "static/name-3a519127f7a422fae624cad32b22dc78.png";